module.exports = __webpack_public_path__ + "img/enveloppe.8a11c5f34e3fd9dd7d60fe3c3a68efd4.svg";